<template>
  <div>
    <div class="tb-list-item-cell">
      <div class="tb-list-item-cell-l flex">
        <span>{{data.typeText}}</span>
        <span class="light flex" @click="downloadFile" style="margin-left:6px;cursor: pointer;">
          <Icon type="md-document" />
          {{data.importFileName}}
          <Icon type="md-download" style="margin-left:5px;" v-if="this.data.result" />
        </span>
      </div>
      <div class="tb-list-item-cell-r">
        <span style="margin-right:5px;"><Icon type="md-contact" />{{data.importerName}}</span> {{data.importDatetimeText}}
      </div>
    </div>
    <div class="tb-list-item-cell">
      <div class="tb-list-item-cell-l light">
        <Badge :status="statusIcon" />
        <span>{{statusLabel}}</span>
      </div>
      <div class="tb-list-item-cell-r" style="flex-basis: 60%;">
          <span>{{data.resultDescription}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { saveFile } from '@/util'
import auth from '@/util/auth'

export default {
  data() {
    return {

    }
  },
  computed: {
    statusIcon() {
      return this.data.result ? 'error' : 'success'
    },
    statusLabel() {
      return this.data.state == 1 ? '处理中' : this.data.result ? '失败' : '成功'
    },
    genderIcon() {
      return this.data.gender == 0 ? 'ios-man' : 'ios-woman-outline'
    },
    // summary() {
    //   // let msg = this.data.resultDescription.match(/^[\w\W]+(成功条数|失败)：\d+?$/)
    //   return this.data.resultDescription ? this.data.resultDescription.split(/[\r\n]/).filter(i => /(成功|失败)/.test(i)).join('；') : ''
    // },
    // desc() {
    //   return this.data.resultDescription ? this.data.resultDescription.split(/[\r\n]/) : []
    // }
  },
  monuted() {
    console.log(this.$props)
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  methods: {
    downloadFile() {
      if (this.data.result) {
        if(auth.hasAuthority('setting.imp.download')){
          this.$request.imptFileDownload(this.data.id).then(resp => {
            saveFile(resp, this.data.importFileName)
          })
        }
      }
    }
  }
}

</script>
<style lang='scss'>
.poptip-cnt {
  text-align: left;
  color: rgba(0, 0, 0, .7);
  font-size: 12px;
  line-height: 2em;
}

</style>
